<template>
  <div>
    <div class="registrationSurface">
      <div class="table_conent">
        <template>
          <div class="table_title">操作日志</div>

          <el-table
            class="tableBox"
            style="height:100%"
            :header-cell-style="{background:'#F1F6F9',color:'#606266',width: '100%'}"
            :data="tableData"
            border
          >
            <el-table-column label="账号" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.user_name}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作模块" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.module}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dataTime" label="操作内容" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.content}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作时间" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.create_time}}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column label="经理分配" align="center" width="160">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.value"
                  placeholder="请选择"
                  @change="optionManager"
                  v-if="scope.row.status == 0"
                >
                  <el-option
                    v-for="item in selectData"
                    :key="item.agent_number"
                    :label="item.agent_name"
                    :value="item.agent_number"
                  ></el-option>
                </el-select>

                <span v-else>{{scope.row.agent_number}}</span>
              </template>
            </el-table-column> -->
          </el-table>
        </template>
      </div>
    </div>
    <div style="text-align: right;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as sysApi from "../../common/sys";

export default {
	data() {
		return {
			value: "",
			tableData: [],
			selectData: [
				{
					agent_name: "",
					agent_number: "",
					id: "",
				},
			],
			parme: {
				params: {
					page: "1",
					page_size: "10",
				},
			},
			total: null,
		};
	},
	created() {
		// this.initManager();
		this.initQuery();
	},
	methods: {
		// 初始化分配经理
		// initManager() {
		//   this.$http.get(this.$api.api.read_manage).then(res => {
		//     if (res.data.code != 1) {
		//       return this.$message.error(res.data.result);
		//     }
		//     this.selectData = res.data.result;
		//   });
		// },
		// 列表
		initQuery() {
			this.$http.get("https://new-mgr.yebaojiasu.com/api/v1/new_mgr/logs", this.parme).then((res) => {
				if (res.data.code != 200) {
					return this.$message.error(res.data.result);
				}
				this.tableData = res.data.data;
				this.total = res.data.total_count;

        console.log(res.data);
			});
			
		},
		handleCommand(command) {
			console.log(command);
			console.log(this.parme.params.status);
			this.parme.params.status = command;
			this.initQuery();
		},
		// 分页
		handleCurrentChange(val) {
			this.parme.params.page = val;
			this.initQuery();
		},
	},
};
</script>

<style scoped lang="scss">
.registrationSurface {
	// padding: 10px;
	overflow: auto;
	.table_conent {
		padding-top: 10px;
		.table_title {
			border: 1px solid #ebeef5;
			border-bottom: 0px;
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			height: 49px;
			line-height: 49px;
			background: #f1f6f9;
		}
		.table_btn {
			width: 80px !important;
		}
	}
}
.registrationSurface .table_conent .table_btn[data-v-6a5a20f6] {
	width: 100px !important;
}
.imgdelManger {
	cursor: pointer;
	padding-right: 20px;
}
</style>
